import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
import { errorDuck } from '../error';
import * as UTIL from '../../util';
import { CATALOGUETYPES } from '../../constants';
import { purchaseConfirmation, toPascal } from '../../util';

var Filter = require('bad-words');

var filter = new Filter();
var Creators = Actions.Creators;
var offlineOrdersRequest = Creators.offlineOrdersRequest;
var offlineOrders = Creators.offlineOrders;
var offlineSearchRequest = Creators.offlineSearchRequest;
var offlineSearchRetailProduct = Creators.offlineSearchRetailProduct;
var offlineAddToCart = Creators.offlineAddToCart;
var closeAddTo = Creators.closeAddTo;
var offlineCartRequest = Creators.offlineCartRequest;
var offlineCartResponse = Creators.offlineCartResponse;
var requestShippingModes = Creators.requestShippingModes;
var recieveShippingModes = Creators.recieveShippingModes;
var setShippingMode = Creators.setShippingMode;
var patchItemCart = Creators.patchItem;
var deleteFromCart = Creators.deleteFromCart;
var clearRetailStates = Creators.clearRetailStates;
var requestPostTip = Creators.requestPostTip;
var recievePostTip = Creators.recievePostTip;
var recieveValidateCart = Creators.recieveValidateCart;
var hideValidateCart = Creators.hideValidateCart;
var requestSubmitCart = Creators.requestSubmitCart;
var recieveSubmitCart = Creators.recieveSubmitCart;
var resetLoading = Creators.resetLoading;
var closeCheckout = Creators.closeCheckout;
var hitCheckout = Creators.setGoToCheckout;
var getCustomer = Creators.getCustomer;
var assignCust = Creators.assignCust;
var resetCustList = Creators.resetCustList;
var setLoader = Creators.setLoader;
var setOfflineSelectedOrder = Creators.setOfflineSelectedOrder;
var requestPromoCode = Creators.requestPromoCode;
var recievePromoCode = Creators.recievePromoCode;
var removePromoCode = Creators.removePromoCode;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var resetError = errorOperations.resetError;

var constructError = function constructError(err) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cb7508";

  try {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: err.Errors[0]
          }
        }
      }
    };
  } catch (_unused) {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: undefined
          }
        }
      }
    };
  }
};

export var newCart = function newCart(state, json) {
  var retailItems = [];
  var cart = Array.isArray(json.CartLines) ? json.CartLines : [];
  cart.forEach(function (item) {
    var _item$Product;

    var catalogName = item === null || item === void 0 ? void 0 : (_item$Product = item.Product) === null || _item$Product === void 0 ? void 0 : _item$Product.CatalogName;

    switch (catalogName) {
      case CATALOGUETYPES.retail:
        retailItems.push(item);
        break;
    }
  });
  console.log('Check state: ', state.cart);
  var a = {
    cart: cart,
    destructuredCart: {
      retailItems: retailItems
    },
    price: _objectSpread({}, json.Price),
    isRetail: Boolean(retailItems.length)
  };
  console.log('test new cart:', a);
  return a;
};

var getOfflineOrders = function getOfflineOrders(pageIndex, orderStatus, itemsPerPage, orderSort, sortColumn, searchText, startDate, endDate) {
  var orderStatusUpdated = orderStatus === "All" ? "" : orderStatus;
  var appendFilter = "".concat(pageIndex, "&orderStatus=").concat(orderStatusUpdated, "&pageSize=").concat(itemsPerPage, "&orderBy=").concat(sortColumn, "&direction=").concat(orderSort, "&searchText=").concat(searchText);

  if (startDate && startDate !== 'Invalid date' && endDate && endDate !== 'Invalid date') {
    appendFilter = "".concat(appendFilter, "&startDate=").concat(startDate, "T01:00:00&endDate=").concat(endDate, "T23:55:00");
  }

  return function (dispatch) {
    dispatch(offlineOrdersRequest());
    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.offline.getOrders).concat(appendFilter)).then(function (json) {
      dispatch(offlineOrders({
        orders: json
      }));
      return json;
    }).catch(function (err) {
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var searchRetailProduct = function searchRetailProduct(productId) {
  return function (dispatch) {
    dispatch(offlineSearchRequest());
    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.offline.getShops, "/").concat(productId)).then(function (json) {
      dispatch(offlineSearchRetailProduct({
        retailProducts: json
      }));
      return json;
    }).catch(function (err) {
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var addItemsToCart = function addItemsToCart(cartItem, variant) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(postCartItems(state, cartItem, variant));
  };
};

var postCartItems = function postCartItems(state, json, variant) {
  var storeId = UTIL.getStoreId(state);
  var data = {
    "options": [],
    //"variantOptions": variantOptions,
    "StoreProductId": null,
    "ProductChainId": json.ProductId,
    "VariantId": variant ? variant.ProductVariantId : "",
    "Quantity": 1,
    "imageUrl": json.Images != null && json.Images.length > 0 ? json.Images[0].ImageUrl : '',
    "total": variant ? variant.AdjustedPrice : json.AdjustedPrice,
    "displayName": json.DisplayName,
    "catalogName": 'shop'
  };
  return function (dispatch) {
    return UTIL.apiUtil.fetchPost("".concat(UTIL.apiUtil.API.postCart), data).then(function (json) {
      dispatch(offlineAddToCart({
        cart: json === null || json === void 0 ? void 0 : json.Data
      }));
      var newCartObj = newCart(state, json === null || json === void 0 ? void 0 : json.Data);
      dispatch(offlineCartResponse(newCartObj));
      return json;
    }).catch(function (err) {
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var getCart = function getCart() {
  return function (dispatch, getState) {
    return dispatch(fetchCart(getState()));
  };
};

function fetchCart(state) {
  return function (dispatch) {
    dispatch(offlineCartRequest());
    var storeId = UTIL.getStoreId(state);
    var routeURL = "".concat(UTIL.apiUtil.API.getCart);
    var data = {
      "storeId": storeId
    };
    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      var newCartObj = newCart(state, json);
      dispatch(offlineCartResponse(newCartObj));

      if (json.Id.includes("00000000-0000-0000-0000-000000000000")) {
        // alert("Error: You have a shared cart ")
        dispatch(receiveError(UTIL.buildError(constructError({
          Errors: ["Shared Cart Found"]
        }, "cb7508"))));
      }
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
}

function getShippingModes() {
  return function (dispatch) {
    dispatch(requestShippingModes());
    var routeURL = "".concat(UTIL.apiUtil.API.cart.getShippingMethods);
    return UTIL.apiUtil.fetchGet(routeURL).then(function (json) {
      dispatch(recieveShippingModes(json));
    }).catch(function (err) {
      console.log(err, "err in Delivery Modes"); // const message = UTIL.buildInternalError('cb7504');
      // return dispatch(receiveError(UTIL.buildError(message)))
    });
  };
}

var updateCartLine = function updateCartLine(lineId, options, newQuantity) {
  return function (dispatch, getState) {
    dispatch(patchItemCart());
    var state = getState();
    var routeURL = UTIL.apiUtil.API.updateCart;
    var data = {
      "cartLineId": lineId,
      "quantity": newQuantity,
      "options": options,
      "specialInstruction": ""
    };
    return UTIL.apiUtil.fetchPatch(routeURL, data).then(function (json) {
      dispatch(offlineCartResponse(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

function deleteCartSend(lineId) {
  return function (dispatch, getState) {
    dispatch(deleteFromCart());
    var state = getState();
    var routeURL = UTIL.apiUtil.API.deleteCart;
    var data = {
      "cartLineId": lineId
    };
    return UTIL.apiUtil.fetchDelete(routeURL, data).then(function (json) {
      dispatch(offlineCartResponse(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
}

var postRetailOrder = function postRetailOrder(addressInfo, deliveryMode) {
  return function (dispatch, getState) {
    var _state$account, _state$account$aadRes;

    dispatch(offlineCartRequest());
    var state = getState();
    var routeURL = UTIL.apiUtil.API.cart.setShippingMethods;
    console.log('Shipping modes: ', state.cart.shippingMode, deliveryMode);
    var selectedMode = state.offline.shippingModes.filter(function (mode) {
      return mode.name.toLowerCase() === deliveryMode;
    });
    var data = {
      "OrderShippingPreferenceType": "1",
      "ShippingMethods": selectedMode,
      "ShippingAddresses": [addressInfo]
    };
    var token = (_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      var pascal = toPascal(json);
      dispatch(offlineCartResponse(newCart(state, pascal.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
      throw "Error";
    });
  };
};

var postTip = function postTip(amount, percent) {
  return function (dispatch, getState) {
    dispatch(requestPostTip());
    var state = getState();
    var routeURL = UTIL.apiUtil.API.setTip;
    var data = {
      amount: amount,
      tipPercentage: String(percent)
    };
    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      dispatch(recievePostTip());
      dispatch(offlineCartResponse(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var validateOrder = function validateOrder() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.offline.isRetail) {
      return new Promise(function (resolve) {
        return resolve(dispatch(recieveValidateCart()));
      });
    }
  };
};

var submitOrder = function submitOrder(payload) {
  return function (dispatch, getState) {
    dispatch(requestSubmitCart());
    var state = getState();
    var routeURL = UTIL.apiUtil.API.submitCart;
    var _payload$paymentInfo = payload.paymentInfo,
        paymentInfo = _payload$paymentInfo === void 0 ? {} : _payload$paymentInfo,
        _payload$cardInfo = payload.cardInfo,
        cardInfo = _payload$cardInfo === void 0 ? {} : _payload$cardInfo;

    var data = _objectSpread(_objectSpread({}, paymentInfo), cardInfo); //Post DeliveryMode


    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      purchaseConfirmation({
        cartInfo: state.cart.cart,
        priceInfo: state.cart.price,
        submitInfo: json.Data,
        foodInfo: state.cart.food,
        caterInfo: state.cart.cater,
        retailInfo: state.cart.retail,
        location: state.location.location,
        userInfo: {
          type: paymentInfo.usertype,
          billingMethod: paymentInfo.billingmethod,
          billingZip: cardInfo.zip
        }
      });
      dispatch(recieveSubmitCart({
        submitInfo: json.Data,
        paymentInfo: data
      }));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var setSelectedOrder = function setSelectedOrder(selectedOrder) {
  return function (dispatch) {
    return dispatch(setOfflineSelectedOrder({
      selectedOrder: selectedOrder
    }));
  };
};

var resetGoToCheckout = function resetGoToCheckout() {
  var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    return dispatch(hitCheckout({
      goToCheckout: toggle
    }));
  };
};

var getCusomerList = function getCusomerList(emailId) {
  return function (dispatch) {
    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.offline.getCustList).concat(emailId)).then(function (json) {
      dispatch(getCustomer({
        customerList: json
      }));
      return json;
    }).catch(function (err) {
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var assignCustomer = function assignCustomer(customer) {
  return function (dispatch) {
    var routeURL = "".concat(UTIL.apiUtil.API.offline.assignCustomer);
    var data = {
      "customerid": customer.AccountNumber
    };
    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      dispatch(assignCust({
        assigned: json
      }));
      return json;
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var resetCustomerList = function resetCustomerList() {
  return function (dispatch) {
    return dispatch(resetCustList());
  };
};

var setLoaderAfterAssign = function setLoaderAfterAssign() {
  return function (dispatch) {
    return dispatch(setLoader());
  };
};

var resetAssign = function resetAssign() {
  return function (dispatch) {
    return dispatch(assignCust({
      assigned: false
    }));
  };
};

var setPromoCode = function setPromoCode(promoCode) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(requestPromoCode());
    var routeURL = UTIL.apiUtil.API.setPromoCode;
    var data = {
      "couponcode": promoCode
    }; // const token = state.account?.aadResponse?.jwtIdToken;

    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      dispatch(recievePromoCode(promoCode));
      dispatch(offlineCartResponse(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var deletePromoCode = function deletePromoCode(promoCode) {
  return function (dispatch, getState) {
    dispatch(requestPromoCode());
    var routeURL = UTIL.apiUtil.API.deletePromoCode;
    return UTIL.apiUtil.fetchDelete(routeURL, {
      "couponCode": promoCode
    }).then(function (json) {
      dispatch(removePromoCode(promoCode));
      dispatch(offlineCartResponse(newCart(getState(), json.Data)));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

export default {
  clearRetailStates: clearRetailStates,
  getShippingModes: getShippingModes,
  setShippingMode: setShippingMode,
  getOfflineOrders: getOfflineOrders,
  searchRetailProduct: searchRetailProduct,
  addItemsToCart: addItemsToCart,
  closeAddTo: closeAddTo,
  getCart: getCart,
  updateCartLine: updateCartLine,
  deleteCartSend: deleteCartSend,
  postRetailOrder: postRetailOrder,
  submitOrder: submitOrder,
  postTip: postTip,
  validateOrder: validateOrder,
  hideValidateCart: hideValidateCart,
  resetGoToCheckout: resetGoToCheckout,
  getCusomerList: getCusomerList,
  assignCustomer: assignCustomer,
  resetCustomerList: resetCustomerList,
  setLoaderAfterAssign: setLoaderAfterAssign,
  setSelectedOrder: setSelectedOrder,
  resetAssign: resetAssign,
  closeCheckout: closeCheckout,
  setPromoCode: setPromoCode,
  deletePromoCode: deletePromoCode
};